export default function PHP_stat() {
  return (
    <div>
      <h1>PHP_stat</h1>
    </div>
  );
}
